// extracted by mini-css-extract-plugin
module.exports = {"left":"Image_Card_left__ZM-IR","right":"Image_Card_right__1rhLv"};